import angular from 'angular';

angular.module('myConsultApp').directive('inputSelectSync', () => {
  return {
    templateUrl: 'templates/v2/input-select-sync.html',
    restrict: 'E',
    scope: {
      id: '@',
      placeholder: '@',
      options: '=',
      titleField: '@',
      valueField: '@',
      initialValue: '=',
      disabled: '=',
      onSelect: '&',
    },
    link: ($scope) => {
      $scope.value = $scope.initialValue;

      $scope.isVisible = false;

      $scope.init = () => {
        $scope.selectedOption = $scope.options.find(
          (option) => option[$scope.valueField] === $scope.value,
        );

        $scope.currentData = $scope.selectedOption
          ? $scope.selectedOption[$scope.titleField]
          : $scope.placeholder;
      };

      $scope.selectOption = (option) => {
        $scope.selectedOption = option;
        $scope.currentData = option[$scope.titleField];
        $scope.onSelect({ option: $scope.selectedOption });
      };

      $scope.showOptions = () => {
        if ($scope.disabled) {
          return;
        }

        $scope.isVisible = !$scope.isVisible;
      };

      $scope.init();

      $scope.$watch('initialValue', () => {
        $scope.value = $scope.initialValue;
        $scope.init();
      });
    },
  };
});
